if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false; 
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);

        const uploadContentExists = document.getElementById('uploadContent');
        const sellingPlanInput = this.form.querySelector(
            'input[name="selling_plan"]:checked'
          );

        const hasSellingPlan = !!sellingPlanInput;

        if(hasSellingPlan ) {
        formData.append(
          'properties[keepshake_subscription]',
          hasSellingPlan ? 'true' : 'false'
        );
      }
  
        if (!uploadContentExists) {
          console.log('✓ No video upload required for this product');
          return this.proceedWithNormalCheckout(formData);
        }

        const embedDiv = document.getElementById('videoMessageContainer');

        if (!window.uploadedVideoUrl) {
          if (embedDiv) {
            embedDiv.style.display = 'block';
            embedDiv.innerHTML = `<p style="color:red; font-weight:bold;">Please upload your video before adding to cart.</p>`;
          }
          this.resetButtonState();
          return;
        }

        const variantId = formData.get('id');
        if (!variantId) {
          console.error(' Variant ID is missing!');
          alert('Error: No product variant selected. Please refresh the page.');
          this.resetButtonState();
          return;
        }
        console.log(' Variant ID from form:', variantId);


        let selectedVariant = this.getSelectedVariantOption();
        console.log(' Selected Variant Option:', selectedVariant);

        const videoId = this.parseVideoUrl(window.uploadedVideoUrl);
        if (!videoId) {
          console.error(' Failed to parse video ID');
          alert('Error: Invalid video URL. Please re-upload your video.');
          this.resetButtonState();
          return;
        }

        const expirationDate = this.calculateExpirationDate(selectedVariant);
        console.log(' Expiration Date:', expirationDate);
        console.log(' Variant:', selectedVariant);

        const finalVideoUrl = this.generateFinalUrl(videoId, expirationDate);

        try {
          const qrCodeDataUrl = await this.generateQRCode(finalVideoUrl);
          if (!qrCodeDataUrl) throw new Error('Failed to generate QR code');

          const canvasImageUrl = await this.getCanvasImageUrl();
          if (!canvasImageUrl) throw new Error('Failed to capture canvas preview');

          const mergedImageDataUrl = await this.mergeQRWithCanvasAtPlaceholder(canvasImageUrl, qrCodeDataUrl);
          const watermarkedImageDataUrl = await this.addWatermark(mergedImageDataUrl, "QR4Keeps");


          const printSizeImageUrl = await this.generatePrintSizeImage(mergedImageDataUrl);
          // if (printSizeImageUrl) {
          //   formData.append('properties[_Print Size Image]', printSizeImageUrl);
          // }
          if (printSizeImageUrl) {
            const sizeSelect = document.querySelector(
              '.size-dropdown-select'
            );

            const selectedSize = sizeSelect?.value?.trim() || '';

            formData.append(
              'properties[_Print Size Image]',
              printSizeImageUrl
            );

            formData.append(
              'properties[_Print Size]',
              selectedSize
            );
          }         

          const uploadedFinalImageUrl = await this.uploadImageToServer(mergedImageDataUrl, 'final');
          const uploadedWatermarkImageUrl = await this.uploadImageToServer(watermarkedImageDataUrl, 'watermarked');

          if (!uploadedFinalImageUrl || !uploadedWatermarkImageUrl) {
            throw new Error('Failed to upload images');
          }


          formData.append('properties[_Video URL]', window.uploadedVideoUrl);
          formData.append('properties[_Expiration Date]', expirationDate);
          formData.append('properties[_Final Image]', uploadedFinalImageUrl);
          formData.append('properties[_Watermarked Image]', uploadedWatermarkImageUrl);
          formData.append('properties[_QR Video URL]', finalVideoUrl);

          console.log(' Adding to cart with:', {
            'Variant ID': variantId,
            'Variant Option': selectedVariant,
            'Expiration': expirationDate
          });

          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const response = await fetch(`${routes.cart_add_url}`, config);
          if (!response.ok) {
            throw new Error(`Cart submission failed with status ${response.status}`);
          }

          const data = await response.json();

          if (data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message,
            });
            this.handleErrorMessage(data.description);
          } else {
            console.log(' Successfully added to cart!');
            
            if (this.cart) {
              this.cart.renderContents(data);
            }

            if (embedDiv) {
              embedDiv.style.display = 'block';
              embedDiv.innerHTML = `<p style="color:green; font-weight:bold;">Redirecting...</p>`;
            }

            setTimeout(() => {
              window.location.href = window.routes.cart_url;
            }, 500);
          }
        } catch (e) {
          console.error(' Error:', e);
          this.handleErrorMessage('An error occurred. Please try again.');
          
          if (embedDiv) {
            embedDiv.style.display = 'block';
            embedDiv.innerHTML = `<p style="color:red; font-weight:bold;">Error: ${e.message}</p>`;
          }
        } finally {
          this.resetButtonState();
        }
      }

      getSelectedVariantOption() {


        const variantSelect = document.querySelector('select[name="options[QR Access]"]');
        if (variantSelect && variantSelect.value) {
          console.log('Found variant from select:', variantSelect.value);
          return variantSelect.value;
        }

        const checkedRadio = document.querySelector('input[name="options[QR Access]"]:checked');
        if (checkedRadio && checkedRadio.value) {
          console.log('Found variant from radio:', checkedRadio.value);
          return checkedRadio.value;
        }

        const fieldset = document.querySelector('fieldset');
        if (fieldset) {
          const checkedInput = fieldset.querySelector('input:checked');
          if (checkedInput && checkedInput.value) {
            console.log('Found variant from fieldset:', checkedInput.value);
            return checkedInput.value;
          }
        }


        const variantId = this.form.querySelector('[name=id]').value;
        if (window.ShopifyProduct && window.ShopifyProduct.variants) {
          const variant = window.ShopifyProduct.variants.find(v => v.id == variantId);
          if (variant) {

            if (variant.options && variant.options.length > 0) {
              console.log('Found variant from ShopifyProduct.variants:', variant.options[0]);
              return variant.options[0];
            }

            if (variant.title && variant.title !== 'Default Title') {
              console.log('Found variant from ShopifyProduct title:', variant.title);
              return variant.title;
            }
          }
        }


        if (window.currentVariant && window.currentVariant.option1) {
          console.log('Found variant from window.currentVariant:', window.currentVariant.option1);
          return window.currentVariant.option1;
        }

        console.warn(' Could not determine variant, using default: 1-Year Access');
        return "1-Year Access";
      }

      resetButtonState() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        this.querySelector('.loading__spinner').classList.add('hidden');
        this.submitButton.removeAttribute('aria-disabled');
      }

       parseVideoUrl(cdnUrl) {
            try {
            const url = new URL(cdnUrl);
            const pathname = url.pathname;

            const marker = '/uploads/';
            const firstIndex = pathname.indexOf(marker);
            if (firstIndex === -1) return '';
                const videoPath = pathname.substring(firstIndex + marker.length);
                return videoPath.split('?')[0]; 
              } catch (error) {
            console.error('Error parsing video URL:', error);
            return '';
            }
      }

      calculateExpirationDate(variant) {
        const now = new Date();
        let expirationDate;

        switch(variant) {
          case "1-Year Access":
            expirationDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
            break;
          case "3-Year Access":
            expirationDate = new Date(now.getFullYear() + 3, now.getMonth(), now.getDate());
            break;
          case "Lifetime Access":
            expirationDate = new Date(now.getFullYear() + 50, now.getMonth(), now.getDate());
            break;
          case "Extended Access":
            expirationDate = new Date(now.getFullYear() + 50, now.getMonth(), now.getDate());
            break;
          default:
            console.warn('Unknown variant, defaulting to 1 year:', variant);
            expirationDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
        }

        return expirationDate.toISOString();
      }

      generateFinalUrl(videoId, expirationDate) {
        const encodedDate = btoa(expirationDate);
        return `https://qr4keeps.com/pages/videos-dislpay?id=${videoId}&ed=${encodedDate}`;
      }

      
    generateQRCode(url) {
        return new Promise((resolve, reject) => {
          try {
            const qrSize = 250;
            const border = 4;
            const padding = 12;
            const panelAlpha = 0.7;

            const qrContainer = document.createElement("div");

            const qr = new QRCode(qrContainer, {
              text: url,
              width: qrSize,
              height: qrSize,
              colorDark: "#000000",
              colorLight: "rgba(255,255,255,0)", 
              correctLevel: QRCode.CorrectLevel.L,
            });


            setTimeout(() => {
              const qrCanvas = qrContainer.querySelector("canvas");
              
              if (!qrCanvas) {
                console.error("QR canvas not generated");
                resolve(null);
                return;
              }

              const outSize = qrSize + 2 * (border + padding);
              const out = document.createElement("canvas");
              out.width = outSize;
              out.height = outSize;
              const ctx = out.getContext("2d");

              ctx.fillStyle = `rgba(255,255,255,${panelAlpha})`;
              ctx.fillRect(0, 0, outSize, outSize);

              const offset = border + padding;
              ctx.drawImage(qrCanvas, offset, offset, qrSize, qrSize);

              resolve(out.toDataURL("image/png"));
            }, 100); 


          } catch (e) {
            console.error("QR generation error:", e);
            reject(e);
          }
        });
      }

      getTargetDimensions(previewInner) {
        const imageSizeAttr = previewInner?.dataset?.imageSize;
        if (!imageSizeAttr) return null;

        const parts = imageSizeAttr.split('*').map(parseFloat);
        if (parts.length !== 2 || parts.some(isNaN)) {
          console.warn('Invalid data-image-size format, expected "W*H":', imageSizeAttr);
          return null;
        }

        const [wIn, hIn] = parts;
        const targetWidth  = Math.round(wIn * 300);
        const targetHeight = Math.round(hIn * 300);
        console.log(`data-image-size="${imageSizeAttr}" → ${targetWidth}×${targetHeight}px @ 300 DPI`);
        return { width: targetWidth, height: targetHeight };
      }

     async getCanvasImageUrl() {
        const previewElement = document.getElementById('previewInner');
        if (!previewElement) {
          return this.createFallbackCanvasImage();
        }

        const isVideoCard = document.querySelector('.custom-video-card') !== null;
        if (isVideoCard) {
          return await this.captureVideoCardManually(previewElement);
        }

        const targetDims = this.getTargetDimensions(previewElement);
        const scaleX = targetDims ? targetDims.width  / previewElement.offsetWidth  : 3;
        const scaleY = targetDims ? targetDims.height / previewElement.offsetHeight : 3;

        const scale  = targetDims ? Math.max(scaleX, scaleY) : 3;

        this._captureWidth  = previewElement.offsetWidth;
        this._captureHeight = previewElement.offsetHeight;

        console.log(`html2canvas scale: ${scale}${targetDims ? ' (from data-image-size)' : ' (fallback)'}`);

        try {
          const canvas = await html2canvas(previewElement, {
            backgroundColor: null,
            useCORS: true,
            allowTaint: true,
            scale: scale,
            logging: false,
            removeContainer: true,
            foreignObjectRendering: false,
            ignoreElements: (element) => element.id === 'draggableqr-placeholder',
            onclone: (clonedDoc) => {
              clonedDoc.querySelectorAll('script').forEach(s => s.remove());
              const qr = clonedDoc.getElementById('draggableqr-placeholder');
              if (qr) qr.remove();

              const placeholder = clonedDoc.querySelector('#draggablePlaceholder');
              const image = clonedDoc.querySelector('#draggablePlaceholder img[style*="object-fit: cover"]');
              if (image && placeholder) {
                const computedStyle = window.getComputedStyle(image);
                const src = image.src;
                const borderRadius = image.style.borderRadius;
                const width = image.style.width;
                const height = image.style.height;
                const border = computedStyle.border;
                
                placeholder.style.backgroundImage = `url(${src})`;
                placeholder.style.backgroundSize = 'cover';
                placeholder.style.backgroundPosition = 'center';
                placeholder.style.backgroundRepeat = 'no-repeat';
                if (!placeholder.style.width)
                placeholder.style.width = width;

              if (!placeholder.style.height)
                placeholder.style.height = height;

                if (borderRadius) {
                  placeholder.style.borderRadius = borderRadius;
                }
                if (border && border !== 'none') {
                  placeholder.style.border = border;
                }
                
                image.remove();
              }
            }
          });

          return canvas ? canvas.toDataURL('image/png') : this.createFallbackCanvasImage();
        } catch (error) {
          console.error('Error capturing canvas:', error);
          return this.createFallbackCanvasImage();
        }
      }


    async captureVideoCardManually(previewElement) {
      return new Promise((resolve) => {
        const computedStyle = window.getComputedStyle(previewElement);
        const bgImage = computedStyle.backgroundImage;
        const bgPosition = computedStyle.backgroundPosition || "50% 50%";
        const bgSize = computedStyle.backgroundSize || "cover";

        const urlMatch = bgImage.match(/url\(["']?([^"']*)["']?\)/);

        if (!urlMatch || !urlMatch[1]) {
          resolve(this.createFallbackCanvasImage());
          return;
        }

        const rect = previewElement.getBoundingClientRect();
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const targetDims = this.getTargetDimensions(previewElement);

          if (targetDims) {
            canvas.width  = targetDims.width;
            canvas.height = targetDims.height;
          } else {
            canvas.width  = rect.width  * 2;
            canvas.height = rect.height * 2;
          }

          const refWidth  = rect.width;
          const refHeight = rect.height;

          const uniformScale = canvas.width / refWidth;

          const ctx = canvas.getContext('2d');
          let drawWidth, drawHeight, offsetX, offsetY;

          if (bgSize.includes('%')) {
            const percent = parseFloat(bgSize) / 100;
            drawWidth  = refWidth  * percent;
            drawHeight = drawWidth * (img.height / img.width); 
          }
          else if (bgSize === 'cover') {
            const refAspect = refWidth / refHeight;
            const imgAspect = img.width / img.height;
            if (imgAspect > refAspect) {
              drawHeight = refHeight;
              drawWidth  = img.width * (refHeight / img.height);
            } else {
              drawWidth  = refWidth;
              drawHeight = img.height * (refWidth / img.width);
            }
          }
          else if (bgSize === 'contain') {
            const ratio = Math.min(refWidth / img.width, refHeight / img.height);
            drawWidth  = img.width  * ratio;
            drawHeight = img.height * ratio;
          }
          else {
            drawWidth  = refWidth;
            drawHeight = refHeight;
          }

          const [posX, posY] = bgPosition.split(' ');
          const parsePos = (pos, total, drawn) => {
            if (pos.includes('%')) return (total - drawn) * (parseFloat(pos) / 100);
            if (pos.includes('px'))  return parseFloat(pos);
            return (total - drawn) / 2;
          };

          offsetX = parsePos(posX, refWidth,  drawWidth);
          offsetY = parsePos(posY, refHeight, drawHeight);


          ctx.drawImage(
            img,
            offsetX * uniformScale,
            offsetY * uniformScale,
            drawWidth  * uniformScale,
            drawHeight * uniformScale
          );

          resolve(canvas.toDataURL('image/png'));
        };

        img.onerror = () => resolve(this.createFallbackCanvasImage());
        img.src = urlMatch[1];
      });
    }


      createFallbackCanvasImage() {
        const canvas = document.createElement('canvas');
        canvas.width = 1000;
        canvas.height = 1000;
        const ctx = canvas.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 1000, 1000);
        gradient.addColorStop(0, '#8c4a2f');
        gradient.addColorStop(1, '#c7985c');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1000, 1000);
        ctx.fillStyle = 'white';
        ctx.font = 'bold 60px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('QR4Keeps', 500, 500);
        return canvas.toDataURL('image/png');
      }

      // async mergeQRWithCanvasAtPlaceholder(canvasImageUrl, qrCodeDataUrl) {
      //   return new Promise((resolve, reject) => {
      //     const canvasImg = new Image();
      //     const qrImg = new Image();
      //     canvasImg.crossOrigin = 'anonymous';
      //     qrImg.crossOrigin = 'anonymous';
      //     canvasImg.src = canvasImageUrl;
      //     qrImg.src = qrCodeDataUrl;

      //     canvasImg.onload = () => {
      //       const canvas = document.createElement('canvas');
      //       const ctx = canvas.getContext('2d');
      //       canvas.width = canvasImg.width;
      //       canvas.height = canvasImg.height;
      //       ctx.drawImage(canvasImg, 0, 0, canvas.width, canvas.height);

      //       const isVideoCard = document.querySelector('.custom-video-card') !== null;
      //       const qrPlaceholder = document.getElementById('draggableqr-placeholder');
      //       const previewInner = document.getElementById('previewInner');

      //       if (qrPlaceholder && previewInner) {
      //         const qrRect = qrPlaceholder.getBoundingClientRect();
      //         const previewRect = previewInner.getBoundingClientRect();
      //         const qrStyle = window.getComputedStyle(qrPlaceholder);
      //         const scale = canvas.width / previewRect.width;
              
      //         let qrX = (qrRect.left - previewRect.left) * scale;
      //         let qrY = (qrRect.top - previewRect.top) * scale;
      //         let qrSize = Math.max(qrRect.width, qrRect.height) * scale;

      //         if (isVideoCard) {
      //           if (qrStyle.right !== 'auto' && qrStyle.right !== '') {
      //             qrX = canvas.width - qrSize - (parseInt(qrStyle.right) * scale);
      //           }
      //           if (qrStyle.bottom !== 'auto' && qrStyle.bottom !== '') {
      //             qrY = canvas.height - qrSize - (parseInt(qrStyle.bottom) * scale);
      //           }
      //         }

      //         qrX = Math.max(0, Math.min(qrX, canvas.width - qrSize));
      //         qrY = Math.max(0, Math.min(qrY, canvas.height - qrSize));
      //         ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);
      //       } else {
      //         const qrSize = Math.min(canvas.width * 0.2, 400);
      //         const padding = 40;
      //         ctx.drawImage(qrImg, canvas.width - qrSize - padding, canvas.height - qrSize - padding, qrSize, qrSize);
      //       }

      //       resolve(canvas.toDataURL('image/png'));
      //     };

      //     canvasImg.onerror = () => reject(new Error('Canvas image load failed'));
      //     qrImg.onerror = () => reject(new Error('QR image load failed'));
      //   });
      // }

      async mergeQRWithCanvasAtPlaceholder(canvasImageUrl, qrCodeDataUrl) {
        return new Promise((resolve, reject) => {
          const canvasImg = new Image();
          const qrImg    = new Image();
          canvasImg.crossOrigin = 'anonymous';
          qrImg.crossOrigin     = 'anonymous';
          canvasImg.src = canvasImageUrl;
          qrImg.src     = qrCodeDataUrl;

          canvasImg.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx    = canvas.getContext('2d');
            canvas.width  = canvasImg.width;
            canvas.height = canvasImg.height;
            ctx.drawImage(canvasImg, 0, 0, canvas.width, canvas.height);

            const qrPlaceholder = document.getElementById('draggableqr-placeholder');
            const previewInner  = document.getElementById('previewInner');

            if (qrPlaceholder && previewInner) {
              const captureW = this._captureWidth  || previewInner.offsetWidth;
              const captureH = this._captureHeight || previewInner.offsetHeight;
              const scaleX   = canvas.width  / captureW;
              const scaleY   = canvas.height / captureH;

              const inlineStyle   = qrPlaceholder.style;
              const computedStyle = window.getComputedStyle(qrPlaceholder);
              const transform     = computedStyle.transform;
              const hasTransform  = transform && transform !== 'none' && transform !== 'matrix(1, 0, 0, 1, 0, 0)';

              // QR rendered size in screen pixels
              const qrW = qrPlaceholder.offsetWidth;
              const qrH = qrPlaceholder.offsetHeight;

              let qrCenterX, qrCenterY;

              if (hasTransform) {
                // Default middle: top:50% left:50% transform:translate(-50%,-50%)
                // The CSS left/top % point IS the visual center
                const leftPct = parseFloat(inlineStyle.left) / 100;
                const topPct  = parseFloat(inlineStyle.top)  / 100;
                qrCenterX = leftPct * captureW;
                qrCenterY = topPct  * captureH;
              } else {
                // After drag: top/left % is the TOP-LEFT corner, no transform
                const leftPct = parseFloat(inlineStyle.left) / 100;
                const topPct  = parseFloat(inlineStyle.top)  / 100;
                qrCenterX = (leftPct * captureW) + (qrW / 2);
                qrCenterY = (topPct  * captureH) + (qrH / 2);
              }

              const qrSize = Math.max(qrW, qrH) * scaleX;
              let qrX = (qrCenterX * scaleX) - (qrSize / 2);
              let qrY = (qrCenterY * scaleY) - (qrSize / 2);

              // Only for video cards with explicit right/bottom inline positioning
              const isVideoCard = document.querySelector('.custom-video-card') !== null;
              if (isVideoCard) {
                if (inlineStyle.right && inlineStyle.right !== 'auto' && inlineStyle.right !== 'unset' && inlineStyle.right !== '') {
                  const rightPct = parseFloat(inlineStyle.right) / 100;
                  qrX = canvas.width - qrSize - (rightPct * captureW * scaleX);
                }
                if (inlineStyle.bottom && inlineStyle.bottom !== 'auto' && inlineStyle.bottom !== 'unset' && inlineStyle.bottom !== '') {
                  const bottomPct = parseFloat(inlineStyle.bottom) / 100;
                  qrY = canvas.height - qrSize - (bottomPct * captureH * scaleY);
                }
              }

              qrX = Math.max(0, Math.min(qrX, canvas.width  - qrSize));
              qrY = Math.max(0, Math.min(qrY, canvas.height - qrSize));

              ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);

            } else {
              const qrSize  = Math.min(canvas.width * 0.2, 400);
              const padding = 40;
              ctx.drawImage(qrImg, canvas.width - qrSize - padding, canvas.height - qrSize - padding, qrSize, qrSize);
            }

            resolve(canvas.toDataURL('image/png'));
          };

          canvasImg.onerror = () => reject(new Error('Canvas image load failed'));
          qrImg.onerror     = () => reject(new Error('QR image load failed'));
        });
      }

      async addWatermark(imageDataUrl, watermarkText = "QR4Keeps", outputWidth = 100) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = imageDataUrl;

          img.onload = () => {
            const scale = outputWidth / img.width;
            const outputHeight = img.height * scale;

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = outputWidth;
            canvas.height = outputHeight;


            ctx.drawImage(img, 0, 0, outputWidth, outputHeight);

            const fontSize = Math.max(outputWidth * 0.1, 16);
            ctx.font = `bold ${fontSize}px Arial`;
            ctx.fillStyle = "rgb(255, 255, 255)"; 
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";

            ctx.save();
            ctx.translate(canvas.width / 2, canvas.height / 2);

            ctx.rotate(-Math.atan(canvas.height / canvas.width));

            ctx.fillText(watermarkText, 0, 0);

            ctx.restore();

            resolve(canvas.toDataURL("image/png"));
          };

          img.onerror = () => reject(new Error("Failed to load image"));
        });
      }


      async generatePrintSizeImage(mergedImageDataUrl) {
        try {
          const isStickerProduct = document.querySelector('[data-print-type="Sticker"]');
          if (!isStickerProduct) {
            console.log('Not a sticker product, skipping print size image');
            return null;
          }

          const sizeSelect = document.querySelector('.size-dropdown-select');
          if (!sizeSelect || !sizeSelect.value) {
            console.warn('No size selected, skipping print size image');
            return null;
          }

          const selectedSize = sizeSelect.value.trim();
          const parts = selectedSize.split('*').map(parseFloat);
          if (parts.length !== 2 || parts.some(isNaN)) {
            console.warn('Invalid size format:', selectedSize);
            return null;
          }

          const [cardW, cardH] = parts;
          const DPI = 300;

          const cardWidthPx  = Math.round(cardW * DPI);
          const cardHeightPx = Math.round(cardH * DPI);

          const fullWidth  = Math.round(5.5 * DPI);
          const fullHeight = Math.round(5.5 * DPI);

          console.log(`Print size: ${cardWidthPx}x${cardHeightPx}px centered on ${fullWidth}x${fullHeight}px`);

          return new Promise((resolve, reject) => {
            const cardImg = new Image();
            cardImg.crossOrigin = 'anonymous';
            cardImg.src = mergedImageDataUrl;

            cardImg.onload = () => {

              const canvas = document.createElement('canvas');
              canvas.width  = fullWidth;
              canvas.height = fullHeight;
              const ctx = canvas.getContext('2d');

              const offsetX = Math.round((fullWidth  - cardWidthPx)  / 2);
              const offsetY = Math.round((fullHeight - cardHeightPx) / 2);

              ctx.drawImage(cardImg, offsetX, offsetY, cardWidthPx, cardHeightPx);

              const dataUrl = canvas.toDataURL('image/png');

              this.uploadImageToServer(dataUrl, 'print_size')
                .then(url => {
                  console.log('Print size image uploaded:', url);
                  resolve(url);
                })
                .catch(err => {
                  console.error('Print size image upload failed:', err);
                  resolve(null);
                });
            };

            cardImg.onerror = () => {
              console.error('Failed to load merged image for print size');
              resolve(null);
            };
          });

        } catch (error) {
          console.error('generatePrintSizeImage error:', error);
          return null;
        }
      }

      async uploadImageToServer(dataUrl, imageType) {
        try {
          const blob = this.dataURItoBlob(dataUrl);
          const formData = new FormData();
          const filename = `qr_${imageType}_${Date.now()}.png`;
          formData.append('file', blob, filename);

          // const response = await fetch('https://qr4keeps.cartmade.com/shopify-file-upload/cloudflare-upload.php', {
          const response = await fetch('https://api.qr4keeps.com/shopify-file-upload/cloudflare-upload.php', {
            method: 'POST',
            body: formData,
          });

          if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
          const result = await response.json();
          
          if (result.success && result.fileUrl) {
            return result.fileUrl;
          } else {
            throw new Error(result.error || 'Upload failed');
          }
        } catch (error) {
          console.error(`Upload error (${imageType}):`, error);
          return null;
        }
      }

      dataURItoBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      async proceedWithNormalCheckout(formData) {
          try {
            if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            const response = await fetch(`${routes.cart_add_url}`, config);
            
            if (!response.ok) {
              throw new Error(`Cart submission failed with status ${response.status}`);
            }

            const data = await response.json();

            if (data.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: data.errors || data.description,
                message: data.message,
              });
              this.handleErrorMessage(data.description);
            } else {
              console.log('✓ Successfully added to cart (no video)');
              
              if (this.cart) {
                this.cart.renderContents(data);
              } else {
                window.location.href = window.routes.cart_url;
              }
            }
          } catch (e) {
            console.error('Checkout error:', e);
            this.handleErrorMessage('An error occurred. Please try again.');
          } finally {
            this.resetButtonState();
          }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}